module.exports = __webpack_public_path__ + "img/ic_industria.a5a8558c.svg";